import React from 'react';
import { CrudStyles } from '../shared/Crud';
import { getRoutePointStateMeta } from './routePointStateConfig';

const { StatusBadge } = CrudStyles;

/**
 * Badge de estado de ponto de roteiro.
 *
 * @param {{ state: string|object, compact?: boolean }} props
 */
export default function RoutePointStateBadge({ state, compact = false }) {
    const meta = getRoutePointStateMeta(state);
    const { label, colorToken, icon: Icon } = meta;

    return (
        <StatusBadge
            as="span"
            style={{
                ...(compact ? {} : { minWidth: '8rem' }),
                textTransform: 'none',
            }}
            $active={meta.value === 'SUCCESS'}
            data-color-token={colorToken}
        >
            {Icon ? <Icon /> : null}
            <span>{label}</span>
        </StatusBadge>
    );
}
